<template>
  <el-dialog :title="receiptStatus === 1 ? orderDefine.name : '新增' + orderDefine.name" v-if="addVisible" :visible.sync="addVisible" width="1200px" :show-close="true" class="add text-center" :close-on-click-modal="false" :before-close="onClose" :class="{'cancelOrder': receiptStatus === 1 && detailItem.status === 7}" append-to-body>
    <div class="content flex-column">
      <div class="stutas" v-if="receiptStatus === 1">
        {{detailItem.status === 1 ? '开单' : detailItem.status === 2 ? '供应商备货' : detailItem.status === 3 ? '供应商送货' : detailItem.status === 4 ? '供应商送货完成' : detailItem.status === 5 ? '供货完成' : detailItem.status === 6 ? '已结账' : detailItem.status === 7 ? '作废单据' : '坏账'}}
      </div>
      <div class="bg-f3f4f7 mb-10">
        <el-form class="plr-20 ptb-8">
          <el-row :gutter="40">
            <el-col :span="12" v-if="orderDefine.type === 4 || orderDefine.type === 5 || orderDefine.type === 6 || orderDefine.type === 12 || orderDefine.type === 13">
              <el-form-item>
                <div class="flex align-center">
                  <div class="font-12-b9b9b9">选择要退的单据：</div>
                  <div v-if="receiptStatus === 1">{{detailItem.chargebackCode}}</div>
                  <div class="flex align-center" v-else>
                    <div class="font-12-30313a mr-5">{{chargebackCode}}</div>
                    <div :class="chargebackId === null ? 'btn-16-bg-ff5555-big' : 'btn-16-bg-85'" @click="selectReceipt">{{chargebackId === null ? '选择' : '更改'}}</div>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="orderDefine.type === 1 || orderDefine.type === 2 || orderDefine.type === 3 || orderDefine.type === 4 || orderDefine.type === 5 || orderDefine.type === 6 || orderDefine.type === 7 || orderDefine.type === 11 || orderDefine.type === 13">
              <el-form-item>
                <div class="flex align-center">
                  <div class="font-12-b9b9b9">装修地点：</div>
                  <div v-if="receiptStatus !== 1">
                    <div v-if="customerAddress" class="font-12-30313a">{{customerAddress}}</div>
                    <div class="flex align-center" v-else>
                      <div class="mr-5 font-12-ff5555" v-if="customerType !== null">{{customerType === 1 ? '装修客户' : '零售客户'}}</div>
                      <div class="font-12-27 mr-5" v-if="customerName !== null">{{customerName}} / {{address}}</div>
                      <div :class="customerName === null ? 'btn-16-bg-ff5555-big' : 'btn-16-bg-85'" @click="selectAddress">{{customerName !== null ? '更改' : '选择'}}</div>
                    </div>
                  </div>
                  <div v-else class="font-12-30313a">{{detailItem.customerName}} / {{detailItem.address}}</div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="orderDefine.type === 1 || orderDefine.type === 2 || orderDefine.type === 3 || orderDefine.type === 4 || orderDefine.type === 5 || orderDefine.type === 6 || orderDefine.type === 7 || orderDefine.type === 10 || orderDefine.type === 12">
              <el-form-item>
                <div class="flex align-center">
                  <div class="font-12-b9b9b9" style="letter-spacing: 1px;">供 应 商：</div>
                  <div class="font-12-30313a" v-if="receiptStatus === 1">{{detailItem.businessName}}</div>
                  <div class="flex align-center justify-space-between select flex-1 plr-10 bg-ff cursor" @click="selectBusiness" v-else-if="orderDefine.isSourceOrder !== 1">
                    <div class="font-12-b6b6b6" v-if="(businessName === null || businessName === '') && orderDefine.isSourceOrder !== 1">请选择供应商</div>
                    <div v-else class="font-12-30313a">{{businessName}}</div>
                    <i class="el-icon-arrow-down"></i>
                  </div>
                  <div class="flex align-center justify-space-between flex-1 plr-10" v-else>
                    <div class="font-12-30313a" v-if="(businessName === null || businessName === '') && orderDefine.isSourceOrder === 1">-</div>
                    <div v-else class="font-12-30313a">{{businessName}}</div>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="orderDefine.type === 10 || orderDefine.type === 11 || orderDefine.type === 12 || orderDefine.type === 13 || orderDefine.type === 14 || orderDefine.type === 15">
              <el-form-item>
                <div class="flex align-center">
                  <div class="font-12-b9b9b9">仓<span style="display: inline-block; width: 2em;"></span>库：</div>
                  <div class="font-12-30313a" v-if="receiptStatus === 1 || orderDefine.isSourceOrder === 1">{{detailItem !== null ? detailItem.storehouseName : storehouseName !== null ? storehouseName : '-'}}</div>
                  <el-select v-model="listValue" placeholder="请选择" v-else class="flex-1">
                    <el-option v-for="(item, index) in list" :key="item.id" :label="item.name" :value="index"></el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="orderDefine.type === 1 || orderDefine.type === 2 || orderDefine.type === 3 || orderDefine.type === 7 || orderDefine.type === 11">
              <el-form-item>
                <div class="flex align-center">
                  <div class="font-12-b9b9b9">要货时间：</div>
                  <div class="font-12-30313a" v-if="receiptStatus === 1">{{Utils.formatDate2(detailItem.requireGoodsTime)}}</div>
                  <el-date-picker v-else class="flex-1" type="date" placeholder="请选择时间" format="yyyy.MM.dd " :clearable="false" v-model="requireGoodsTime"></el-date-picker>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="orderDefine.type === 1 || orderDefine.type === 2 || orderDefine.type === 3 || orderDefine.type === 4 || orderDefine.type === 5 || orderDefine.type === 6 || orderDefine.type === 7 || orderDefine.type === 11 || orderDefine.type === 13">
              <el-form-item>
                <div class="flex align-center">
                  <div class="font-12-b9b9b9">项目经理：</div>
                  <div class="font-12-30313a" v-if="receiptStatus === 1">{{detailItem.pmName}}</div>
                  <div class="font-12-b9b9b9" v-else>{{pmName || '-'}}</div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div class="flex align-center">
                  <div class="font-12-b9b9b9">单据编号：</div>
                  <div class="font-12-30313a" v-if="receiptStatus === 1">{{detailItem.code}}</div>
                  <div class="font-12-30313a" v-else>-</div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div class="flex align-center">
                  <div class="font-12-b9b9b9">开单人员：</div>
                  <div class="font-12-30313a" v-if="receiptStatus === 1">{{detailItem.fundName}}</div>
                  <div class="font-12-30313a" v-else>-</div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div class="flex align-center">
                  <div class="font-12-b9b9b9">开单时间：</div>
                  <div class="font-12-30313a" v-if="receiptStatus === 1">{{Utils.formatDate2(detailItem.createTime)}}</div>
                  <div class="font-12-30313a" v-else>-</div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <div class="flex align-center">
                  <div class="font-12-b9b9b9">单据备注：</div>
                  <div class="font-12-30313a" v-if="receiptStatus === 1 && detailItem.status >= 5">{{remark}}</div>
                  <el-input placeholder="请输入" class="flex-1" v-model="remark" v-else :readonly="orderDefine.sourceOrderId !== -1 && orderDefine.isSourceOrder === 1 && chargebackId === null"></el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="flex align-center mb-10">
        <div class="addBtn cursor button  mlr-20" @click="addMaterial" v-if="(orderDefine.isSourceOrder !== 1 || orderDefine.sourceOrderId === -1) && this.btnPermissions.indexOf('save') !== -1">
          <img src="/static/images/customer/chubeikehu.png" alt="">
          <div>新增材料</div>
        </div>
        <div class="flex align-center mlr-20" v-if="orderType == 1 || orderType == 2 || orderType == 3 || orderType == 4 || orderType == 5 || orderType == 6 || orderType == 7 || orderType == 11 || orderType == 13">
          <div class="flex align-center" v-if="controlData.isControl">
            <div class="font-12-30313a mr-40">可用金额：<span class="font-18-82b925">¥{{Utils.toFixedNum(controlData.availableAmount)}}</span></div>
            <div class="font-12-30313a">总可用金额：<span class="font-18-30313a">¥{{Utils.toFixedNum(controlData.total)}}</span></div>
          </div>
          <div class="font-12-30313a" v-else>不限量</div>
        </div>
      </div>
      <div class="plr-20 mb-10" style="height: 300px">
        <erp-table ref="erpTable" :table-footer="tableFooter" :table-data="tableData" :loading="loading" :column-data="columnData" :is-edit="isEdit" @on-delete="onDeleteRow" @on-modify="onModifyRow" modify-method="on-modify" :show-status="true"
                   :customs="[{field: 'operate', visible: this.btnPermissions.indexOf('delete') !== -1},{field: 'availableQuantity', visible: isChargeback}, {field: 'customerPrice', visible: !(orderDefine.type === 10 || orderDefine.type === 12 || orderDefine.type === 14 || orderDefine.type === 15)}, {field: 'totalCustomer', visible: !(orderDefine.type === 10 || orderDefine.type === 12 || orderDefine.type === 14 || orderDefine.type === 15)},{field: 'costPrice', visible: isMaterialAuditor},{field: 'totalCost', visible: isMaterialAuditor}]"></erp-table>
      </div>
    </div>
    <div slot="footer" v-if="(receiptStatus === 1 && detailItem.status < 6) || receiptStatus === 0">
      <button class="btn-30-bg-82b925-big mr-10" :disabled="lockLoading" @click="onPrint" v-if="this.btnPermissions.indexOf('save') === -1 && this.btnPermissions.indexOf('print') !== -1">打印</button>
      <button class="btn-30-bg-82b925-big mr-10" :disabled="lockLoading" @click="onSaveAndPrint" v-if="this.btnPermissions.indexOf('save') !== -1 && this.btnPermissions.indexOf('print') !== -1">保存并打印</button>
      <button class="btn-30-bg-f5971d-s" :disabled="lockLoading" @click="onSave" v-if="this.btnPermissions.indexOf('save') !== -1">保存</button>
    </div>
    <add-materialy ref="addMaterialy" :orderDefine="orderDefine" :receiptStatus="receiptStatus" :storehouseId="storehouseId"></add-materialy>
    <source-materialy ref="sourceMaterialy" :orderDefine="orderDefine" :receiptStatus="receiptStatus" :customerId="customerId"></source-materialy>
    <select-decoration-address ref="selectDecorationAddress"></select-decoration-address>
    <select-return-material-receipt ref="selectReturnMaterialReceipt" :title="backName" :orderDefine="orderDefine"></select-return-material-receipt>
    <el-dialog class="my-dialog text-center" :modal-append-to-body="false" width="1215px" title="选择供应商" :visible.sync="isSupplierShow" append-to-body>
      <choose-supplier @click-supplier="onClickSupplier"></choose-supplier>
    </el-dialog>
    <el-dialog class="my-dialog text-center flex-column" :modal-append-to-body="false" width="1215px" title="打印报表" :visible.sync="isReportShow" :fullscreen="true" append-to-body @close='closeDialogReport'>
      <report :classify-id="5" :id="orderId" :orderDefineId="orderDefine.id"></report>
    </el-dialog>
  </el-dialog>
</template>

<script>
import ErpTable from '@/components/ErpTable'
import Report from '@/components/Report'
import AddMaterialy from '@/pages/order/components/AddMaterialy'
import SourceMaterialy from '@/pages/order/components/sourceMaterialy'
import SelectDecorationAddress from '@/pages/order/components/SelectDecorationAddress'
import SelectReturnMaterialReceipt from '@/pages/order/components/SelectReturnMaterialReceipt'
import ChooseSupplier from '@/components/ChooseSupplier'
export default {
  name: 'addReceipt',
  props: ['receiptStatus', 'orderDefine', 'detailItem', 'backName', 'isEdit', 'btnPermissions', 'orderType', 'tabStatus'],
  components: {Report, ErpTable, AddMaterialy, SelectDecorationAddress, SelectReturnMaterialReceipt, ChooseSupplier, SourceMaterialy},
  data () {
    return {
      isChargeback: false,
      addVisible: false,
      isReportShow: false,
      loading: false,
      list: [],
      listValue: null,
      tableData: [],
      tableFooter: [
        {
          columns: ['totalCost', 'totalCustomer'],
          type: 'sum',
          name: '合计'
        }
      ],
      columnData: [{
        field: 'materialId',
        title: 'id',
        width: '40'
      }, {
        field: 'operate',
        title: '操作',
        width: '70',
        isDefine: true,
        child: [{
          className: 'btn-16-bd-85 btn-hover mr-5',
          title: '删除',
          methodName: 'on-delete',
          type: 'btn'
        }]
      }, {
        type: 'index',
        title: '序号',
        width: '60'
      }, {
        field: 'materialCode',
        title: '材料编码',
        width: '120',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'specialItem',
        title: '特项',
        width: '80'
      }, {
        field: 'materialName',
        title: '材料名称',
        width: '180',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'materialStandard',
        title: '规格',
        width: '100',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'materialMode',
        title: '型号',
        width: '100',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'materialUnit',
        title: '单位',
        width: '80',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'quantity',
        title: '数量',
        width: '100',
        editRender: {
          name: 'input'
        },
        editType: 'number'
      }, {
        field: 'availableQuantity',
        title: '正单量',
        width: '100'
      }, {
        field: 'costPrice',
        title: '采购单价',
        width: '120',
        editRender: {
          name: 'input'
        },
        editType: 'number'
      }, {
        field: 'totalCost',
        title: '采购合价',
        width: '120'
      }, {
        field: 'customerPrice',
        title: '销售单价',
        width: '120',
        editRender: {
          name: 'input'
        },
        editType: 'number'
      }, {
        field: 'totalCustomer',
        title: '销售合价',
        width: '120'
      }, {
        field: 'remark',
        title: '说明',
        minWidth: '150',
        editRender: {
          name: 'input'
        }
      }],
      isSupplierShow: false,
      businessId: null,
      businessName: null,
      address: null,
      customerId: null,
      customerName: null,
      pmId: null,
      pmName: null,
      pmTel: null,
      requireGoodsTime: null,
      remark: null,
      storehouseId: null,
      storehouseName: null,
      chargebackId: null,
      chargebackCode: null,
      changeMaterialList: [],
      addMaterialList: [],
      deleteMaterialList: [],
      customerType: null,
      orderId: null,
      billList: {}, // 单据详情
      customerAddress: null,
      lockLoading: false,
      controlData: {},
      isMaterialAuditor: false
    }
  },
  created () {
    if (this.detailItem.remark) {
      this.remark = this.detailItem.remark
    }
  },
  mounted () {
    if (this.detailItem.status <= 5) {
      this.remark = this.detailItem.remark
    }
    if (this.detailItem) {
      this.businessId = this.detailItem.businessId
      this.businessName = this.detailItem.businessName
    }
    this.getMaterialAuditor()
  },
  methods: {
    getMaterialAuditor () {
      this.axios.post('station/getById', this.qs.stringify({id: this.$store.state.user.roleId})).then(res => {
        if (res.data.success) {
          if (res.data.data.isMaterialAuditor === 1) {
            this.isMaterialAuditor = true
          } else {
            this.isMaterialAuditor = false
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    // 控制开单比例
    getOrderControl () {
      let params = {
        orderDefineId: this.orderDefine.id,
        customerId: this.customerId
      }
      this.axios.post(`order/getAvailableAmount`, params).then(res => {
        if (res.data.success) {
          this.controlData = res.data.data
        }
      })
    },
    getAddData () {
      this.addMaterialList = this.$refs.erpTable.getInsertEvent()
    },
    getData () {
      let params = {
        orderId: this.detailItem.id
      }
      if (this.orderType === 11 || this.orderType === 14) { // 出库，报损
        params.inventoryFlag = 2
      }
      if (this.orderType === 4 || this.orderType === 5 || this.orderType === 6 || this.orderType === 12 || this.orderType === 13) { // 退单
        params.isBack = 1
      }
      this.axios.post(`orderMaterial/list`, params).then(res => {
        if (res.data.success) {
          this.tableData = []
          res.data.data.forEach(i => {
            let arr = ['totalCost']
            if (this.orderDefine.costPriceModify !== 1) {
              arr.push(this.orderDefine.costPriceField)
            }
            if (this.orderDefine.customerPriceModify !== 1) {
              arr.push('customerPrice')
            }
            if (this.tabStatus !== 1) {
              arr.push('quantity')
            }
            if (i.isModified === -1) {
              let unEditableArr = ['materialCode', 'materialName', 'materialMode', 'materialUnit']
              arr = arr.concat(unEditableArr)
            }
            i.totalCost = (i.totalCost).toFixed(2)
            i.totalCustomer = (i.totalCustomer).toFixed(2)
            i.unEditable = arr.join(',')
            this.tableData.push(i)
          })
        }
      })
    },
    getWarehouse () { // 仓库
      this.axios.post(`storehouse/list`, {
        companyId: this.$store.state.companyId
      }).then(res => {
        if (res.data.success) {
          this.list = res.data.data
        }
      })
    },
    addMaterial () { // 添加材料 sourceOrderId -1 主材
      if (this.orderDefine.sourceOrderId === -1) {
        if (this.customerId === null) {
          this.$message({
            type: 'warning',
            message: '请先选择客户!'
          })
        } else {
          this.$refs.sourceMaterialy.addMaterialyVisible = true
          this.$refs.sourceMaterialy.getData()
        }
      } else {
        if (this.orderType === 11) {
          if (this.receiptStatus === 0) {
            if (this.customerId === null) {
              this.$message({
                type: 'warning',
                message: '请先选择客户!'
              })
            } else if (this.storehouseName === null) {
              this.$message({
                type: 'warning',
                message: '请先选择仓库!'
              })
            } else {
              this.$refs.addMaterialy.addMaterialyVisible = true
              this.$refs.addMaterialy.getAllMenu()
            }
          } else {
            this.$refs.addMaterialy.addMaterialyVisible = true
            this.$refs.addMaterialy.getAllMenu()
          }
        } else if (this.orderType === 10 || this.orderType === 14 || this.orderType === 15) {
          if (this.receiptStatus === 0) {
            if (this.storehouseName === null) {
              this.$message({
                type: 'warning',
                message: '请先选择仓库!'
              })
            } else {
              this.$refs.addMaterialy.addMaterialyVisible = true
              this.$refs.addMaterialy.getAllMenu()
            }
          } else {
            this.$refs.addMaterialy.addMaterialyVisible = true
            this.$refs.addMaterialy.getAllMenu()
          }
        } else {
          this.$refs.addMaterialy.addMaterialyVisible = true
          this.$refs.addMaterialy.getAllMenu()
        }
      }
    },
    selectReceipt () {
      this.$refs.selectReturnMaterialReceipt.selectVisible = true
      this.$refs.selectReturnMaterialReceipt.getData()
    },
    selectAddress () {
      this.$refs.selectDecorationAddress.selectVisible = true
      this.$refs.selectDecorationAddress.getData()
    },
    selectBusiness () {
      this.isSupplierShow = true
    },
    onClickSupplier (data) {
      this.businessId = data.id
      this.businessName = data.name
      this.isSupplierShow = false
    },
    onModifyRow (row, column, colName) {
      if (parseFloat(row.quantity) < 0) {
        row.quantity = 1
      }
      if (this.orderDefine.storehouseFlag !== -1) {
        if (row.quantity > row.curBalanceQuantity) {
          row.quantity = row.curBalanceQuantity
        }
      }
      if (this.orderDefine.type === 4 || this.orderDefine.type === 5 || this.orderDefine.type === 6 || this.orderDefine.type === 12 || this.orderDefine.type === 13) {
        if (row.quantity > row.availableQuantity) {
          row.quantity = row.availableQuantity
        }
      }
      if (colName === 'quantity') {
        row.totalCost = (row.quantity * row[this.orderDefine.costPriceField]).toFixed(2)
        row.totalCustomer = (row.quantity * row.customerPrice).toFixed(2)
      } else if (colName === 'costPrice') {
        row.totalCost = (row.quantity * row[this.orderDefine.costPriceField]).toFixed(2)
      } else if (colName === 'customerPrice') {
        row.totalCustomer = (row.quantity * row.customerPrice).toFixed(2)
      }
      this.$refs.erpTable.updateFooter()
    },
    onDeleteRow (row) {
      this.$confirm(`此操作将删除${row.name}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.receiptStatus === 0) {
          this.tableData.forEach((item, index) => {
            if (item.materialId === row.materialId) {
              this.tableData.splice(index, 1)
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
        } else {
          this.$refs.erpTable.remove(row)
          this.getRemoveEvent()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onPrint () {
      this.orderId = this.detailItem.id
      this.$nextTick(() => {
        this.isReportShow = true
      })
    },
    closeDialogReport () {
      this.addVisible = false
    },
    onSaveAndPrint () {
      this.lockLoading = true
      if (this.receiptStatus === 0) {
        let params = {
          name: this.orderDefine.name,
          companyId: this.$store.state.companyId,
          orderDefineId: this.orderDefine.id,
          type: this.orderDefine.type,
          address: this.customerAddress || this.address,
          customerId: this.customerId,
          customerName: this.customerName,
          businessId: this.businessId,
          businessName: this.businessName,
          pmId: this.pmId,
          pmName: this.pmName,
          requireGoodsTime: this.requireGoodsTime,
          remark: this.remark,
          storehouseId: this.storehouseId,
          storehouseName: this.storehouseName,
          chargebackId: this.chargebackId,
          chargebackCode: this.chargebackCode,
          orderMaterialParamList: this.tableData,
          customerType: this.customerType
        }
        if (params.orderMaterialParamList.length === 0) {
          this.$message({
            type: 'warning',
            message: '请添加材料!'
          })
        } else {
          let currentTotal = 0
          for (let i = 0; i < this.tableData.length; i++) {
            currentTotal = currentTotal + parseFloat(this.tableData[i].totalCost)
          }
          if ((this.orderType === 1 || this.orderType === 2 || this.orderType === 3 || this.orderType === 4 || this.orderType === 5 || this.orderType === 6 || this.orderType === 7 || this.orderType === 11 || this.orderType === 13) && this.controlData.isControl && this.controlData.availableAmount < currentTotal) {
            this.$message({
              type: 'warn',
              message: '超出剩余可用金额!'
            })
          } else {
            this.axios.post(`order/save`, params).then(res => {
              if (res.data.success) {
                this.reset()
                this.$message({
                  type: 'success',
                  message: '添加成功!'
                })
                this.orderId = res.data.data.id
                this.$nextTick(() => {
                  this.isReportShow = true
                  this.$parent.getData()
                  // this.$parent.closeOrder()
                  // this.addVisible = false
                })
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }
        }
        setTimeout(() => {
          this.lockLoading = false
        }, 2000)
      } else {
        this.updateRecords()
        if (this.tableData.length - this.deleteMaterialList.length === 0) {
          this.$message({
            type: 'warning',
            message: '请添加材料!'
          })
        } else {
          let currentTotal = 0
          let deleteTotal = 0
          let addTotal = 0
          if (this.tableData.length > 0) {
            for (let i = 0; i < this.tableData.length; i++) {
              console.log(this.tableData[i].totalCost)
              currentTotal = currentTotal + parseFloat(this.tableData[i].totalCost)
            }
          }
          if (this.deleteMaterialList.length > 0) {
            for (let j = 0; j < this.deleteMaterialList.length; j++) {
              deleteTotal = deleteTotal + parseFloat(this.deleteMaterialList[j].totalCost)
            }
          }
          if (this.addMaterialList.length > 0) {
            for (let q = 0; q < this.addMaterialList.length; q++) {
              addTotal = addTotal + parseFloat(this.addMaterialList[q].totalCost)
            }
          }
          if ((this.orderType === 1 || this.orderType === 2 || this.orderType === 3 || this.orderType === 4 || this.orderType === 5 || this.orderType === 6 || this.orderType === 7 || this.orderType === 11 || this.orderType === 13) && this.controlData.isControl && this.controlData.availableAmount < (currentTotal - deleteTotal + addTotal)) {
            this.$message({
              type: 'warn',
              message: '超出剩余可用金额!'
            })
            return
          } else {
            this.axios.post(`order/modify`, {
              name: this.orderDefine.name,
              companyId: this.$store.state.companyId,
              orderDefineId: this.orderDefine.id,
              id: this.detailItem.id,
              changeList: this.changeMaterialList,
              addList: this.addMaterialList,
              deleteList: this.deleteMaterialList
            }).then(res => {
              if (res.data.success) {
                this.reset()
                this.$message({
                  type: 'success',
                  message: '保存成功!'
                })
                this.orderId = res.data.data.id
                this.$nextTick(() => {
                  this.isReportShow = true
                  this.$parent.getData()
                  // this.$parent.closeOrder()
                })
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }
        }
        setTimeout(() => {
          this.lockLoading = false
        }, 2000)
      }
    },
    updateRecords () {
      let updateRecords = this.$refs.erpTable.getUpdateEvent()
      this.changeMaterialList = updateRecords
    },
    getRemoveEvent () {
      let removeRecords = this.$refs.erpTable.getRemoveEvent()
      this.deleteMaterialList = removeRecords
    },
    onSave () {
      console.log(898989898)
      this.lockLoading = true
      if (this.receiptStatus === 0) {
        let params = {
          name: this.orderDefine.name,
          companyId: this.$store.state.companyId,
          orderDefineId: this.orderDefine.id,
          type: this.orderDefine.type,
          address: this.customerAddress || this.address,
          customerId: this.customerId,
          customerName: this.customerName,
          businessId: this.businessId,
          businessName: this.businessName,
          pmId: this.pmId,
          pmName: this.pmName,
          requireGoodsTime: this.requireGoodsTime,
          remark: this.remark,
          storehouseId: this.storehouseId,
          storehouseName: this.storehouseName,
          chargebackId: this.chargebackId,
          chargebackCode: this.chargebackCode,
          orderMaterialParamList: this.tableData,
          customerType: this.customerType
        }
        if (params.orderMaterialParamList.length === 0) {
          this.$message({
            type: 'warning',
            message: '请添加材料!'
          })
        } else {
          let currentTotal = 0
          for (let i = 0; i < this.tableData.length; i++) {
            currentTotal = currentTotal + parseFloat(this.tableData[i].totalCost)
          }
          if ((this.orderType === 1 || this.orderType === 2 || this.orderType === 3 || this.orderType === 4 || this.orderType === 5 || this.orderType === 6 || this.orderType === 7 || this.orderType === 11 || this.orderType === 13) && this.controlData.isControl && this.controlData.availableAmount < currentTotal) {
            this.$message({
              type: 'warn',
              message: '超出剩余可用金额!'
            })
          } else {
            this.axios.post(`order/save`, params).then(res => {
              if (res.data.success) {
                this.reset()
                this.addVisible = false
                this.$message({
                  type: 'success',
                  message: '添加成功!'
                })
                this.$parent.getData()
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }
          setTimeout(() => {
            this.lockLoading = false
          }, 2000)
        }
      } else {
        this.updateRecords()
        if ((this.tableData.length - this.deleteMaterialList.length) + this.addMaterialList.length === 0) {
          this.$message({
            type: 'warning',
            message: '请添加材料!'
          })
        } else {
          let currentTotal = 0
          let deleteTotal = 0
          let addTotal = 0
          if (this.tableData.length > 0) {
            for (let i = 0; i < this.tableData.length; i++) {
              currentTotal = currentTotal + parseFloat(this.tableData[i].totalCost)
            }
          }
          if (this.deleteMaterialList.length > 0) {
            for (let j = 0; j < this.deleteMaterialList.length; j++) {
              deleteTotal = deleteTotal + parseFloat(this.deleteMaterialList[j].totalCost)
            }
          }
          if (this.addMaterialList.length > 0) {
            for (let q = 0; q < this.addMaterialList.length; q++) {
              addTotal = addTotal + parseFloat(this.addMaterialList[q].totalCost)
            }
          }
          console.log(4567)
          if ((this.orderType === 1 || this.orderType === 2 || this.orderType === 3 || this.orderType === 4 || this.orderType === 5 || this.orderType === 6 || this.orderType === 7 || this.orderType === 11 || this.orderType === 13) && this.controlData.isControl && this.controlData.availableAmount < (currentTotal - deleteTotal + addTotal)) {
            this.$message({
              type: 'warn',
              message: '超出剩余可用金额!'
            })
          } else {
            this.axios.post(`order/modify`, {
              name: this.orderDefine.name,
              companyId: this.$store.state.companyId,
              orderDefineId: this.orderDefine.id,
              id: this.detailItem.id,
              changeList: this.changeMaterialList,
              addList: this.addMaterialList,
              deleteList: this.deleteMaterialList,
              remark: this.remark
            }).then(res => {
              if (res.data.success) {
                this.reset()
                this.addVisible = false
                this.$message({
                  type: 'success',
                  message: '保存成功!'
                })
                this.getData()
                this.$parent.getData()
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }
          setTimeout(() => {
            this.lockLoading = false
          }, 2000)
        }
      }
    },
    reset () {
      this.changeMaterialList = []
      this.addMaterialList = []
      this.deleteMaterialList = []
      this.businessId = null
      this.businessName = null
      this.address = null
      this.customerId = null
      this.customerName = null
      this.pmId = null
      this.pmName = null
      this.pmTel = null
      this.requireGoodsTime = null
      this.remark = null
      this.storehouseId = null
      this.storehouseName = null
      this.chargebackId = null
      this.chargebackCode = null
      this.tableData = []
      this.list = []
      this.listValue = null
      this.customerType = null
    },
    onClose () {
      this.reset()
      this.addVisible = false
    }
  },
  watch: {
    listValue (val) {
      if (val !== null) {
        this.storehouseName = this.list[val].name
        this.storehouseId = this.list[val].id
      }
    },
    detailItem (val) {
      if (val) {
        this.customerId = val.customerId
        this.businessId = val.businessId
        this.businessName = val.businessName
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .content {
    height: 500px;
    position: relative;
  }
  .el-form-item{
    margin-bottom: 2px;
  }
  .el-select{
    height: 30px;
  }
  .addBtn{
    background: #fff;
    width: 85px;
    height: 24px;
    color: #30313a;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border-radius: 4px;
  }
  .button{
    border: 1px solid #e2e2e2;
  }
  .select{
    border: 1px solid #e2e2e2;
    border-radius: 4px;
    height: 30px;
    line-height: 30px;
  }
  .selectDisabled{
    border: 1px solid #e2e2e2;
    border-radius: 4px;
    height: 30px;
    line-height: 30px;
    background: #F5F7FA;
  }
  .cancelOrder /deep/ .el-dialog__title{
    color: #ff5555;
  }
  .stutas{
    background: #30313a;
    color: #fff;
    font-size: 12px;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    height: 16px;
    line-height: 16px;
    padding: 0 5px;
    position: absolute;
    top: -32px;
  }
  .content /deep/ .el-date-editor.el-input{
    height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AddReceipt.vue